import Vue from 'vue'
import App from './App'
import router from './router'
import api from './http'
import i18n from './i18n'
import store from './store'
import ElementUI from 'element-ui'
import echarts from 'echarts'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
import '@/assets/iconfont/iconfont.css'
import '../static/css/global.css'

import 'babel-polyfill'
import 'es6-promise/auto'
import 'jquery-ui/ui/widgets/selectable'

import Print from 'vue-print-nb' //打印功能
import '../static/js/drag-dialog' //el-dialog拖动

import scroll from 'vue-seamless-scroll'
import BaiduMap from "vue-baidu-map";
import VueContextMenu from 'vue-contextmenu'

Vue.use(VueContextMenu)
Vue.use(ElementUI);
Vue.use(api);
Vue.use(scroll);
Vue.use(Print);  //注册

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥
  ak: 'fIr63E1WaMTNPkwYo57Oe6RHmivv81LR'
});

Vue.prototype.global = globalConfig;

Vue.prototype.$echarts = echarts;

new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js